import React from 'react'
import { Link } from 'react-router-dom'
// import Swal from 'sweetalert2'
import {useState} from 'react'
function Nav() {
  const [showButton , setShowButton] = useState(false)
  const removeStorageName = () => {
    setTimeout(() => {
        // const user = prompt('Enter Your Name:' , `${window.localStorage.getItem("Name")}`)
        window.localStorage.setItem("Name", "Default-Page"); 
        window.location.reload()
      
    } , 0)
  }
  const handleSettings = () =>{
    setShowButton(!showButton)
  }
  return (
        <React.Fragment>
      <div className="footer">
        <div className="container">
          <div className="content">
            <h3>Made With <span><img src="https://cdn-icons-png.flaticon.com/512/8180/8180722.png" alt="heart" /></span> by <span>محمد المكاوي</span></h3>
              <button className='settings-user' onClick={handleSettings}>
                <div className="image">
                  <img src="https://cdn-icons-png.flaticon.com/512/3098/3098120.png" alt="control buttons" />
                </div>
              </button>
              {showButton === true && (
                <Link to="/notes" className='facebook-button'  onClick={handleSettings}  title='Home Page'>
                  <div className="image" ><img src="https://cdn-icons-png.flaticon.com/512/1828/1828740.png" alt="home-icon"/></div>
                </Link>
              )}
              {showButton == true && (
                <Link to='/notes/addtask' title='add New Task'  onClick={handleSettings} className="add-task" >
                  <img src="https://cdn-icons-png.flaticon.com/512/226/226974.png" alt="add-task" />
                </Link>
              )}
              {showButton === true && (
                <button className='remove-user' title='Log Out'  onClick={removeStorageName}>
                  <div className="image">
                    <img src="https://cdn-icons-png.flaticon.com/512/2574/2574151.png" alt="remove user" />
                  </div>
                </button>
              )}
              
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Nav